export const applyStatus = [
    {key: 1, title: '保存未上传'},
    {key: 2, title: '上传未提交'},
    {key: 3, title: '审批中'},
    {key: 4, title: '审批通过'},
    {key: 5, title: '已驳回'},
]

export const applyStage = [
    {key: 1, title: '外办预审', loadingText: "预审中", confirmText: '预审完成'},
    {key: 2, title: '杭州市政府办公厅', loadingText: "受理中", confirmText: '受理完成'},
    {key: 3, title: '省政府完成', loadingText: "处理中", confirmText: '确认通过'},
]

export const getApplyStatusText = function(status) {
    let res = applyStatus.find(s => s.key == status);
    return res ? res.title : null;
}

export const getStageText = function (stage) {
    let res = applyStage.find(s => s.key == stage);
    return res ? res.title : null;
}

export const getApplyStageText = function (apply) {
    let flow = apply.flow_detail;
    let res = "外办预审";
    if (flow) {
        try {
            flow = JSON.parse(flow);
            flow.sort((a, b) => b.stage - a.stage);
            const last = flow[0];
            res = getStageText(last.stage);
        } catch (e) {
            console.error(e)
        }
    }
    return res;
}
